import { Tooltip, Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { buttonStyle } from './TransitionStyles';

export default function SaveButton() {
  const { formState } = useFormContext();

  return (
    <Tooltip placement="left" arrow title="No changes to save" disableHoverListener={formState.isDirty}>
      <span style={{ width: '100%' }}>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          disableElevation
          disabled={!formState.isDirty}
          fullWidth
          sx={{ ...buttonStyle }}
        >
          {' '}
          Save
        </Button>
      </span>
    </Tooltip>
  );
}
